module.exports = __webpack_public_path__ + "static/media/inst_05.86952ade.png";